// src/graphql/nova-graphql-provider.tsx
import * as React from "react";
import invariant from "invariant";
var NovaGraphQLContext = React.createContext(null);
var NovaGraphQLProvider = ({ children, graphql }) => {
  return /* @__PURE__ */ React.createElement(NovaGraphQLContext.Provider, { value: graphql }, children);
};
NovaGraphQLProvider.displayName = "NovaGraphQLProvider";
var useNovaGraphQL = () => {
  const graphql = React.useContext(NovaGraphQLContext);
  invariant(
    graphql !== null,
    "Nova GraphQL provider must be initialized prior to consumption!"
  );
  return graphql;
};
export {
  NovaGraphQLProvider,
  useNovaGraphQL
};
